import { useLocation } from "react-router-dom";

// Single source of truth for org user roles and which modules each role can open.
// Users are registered once (POST /org-user) and the same account is used by every module;
// each module then shows the dashboard and actions for the user's role.

export const MODULES = {
  MATERIAL_TRACKER: "MATERIAL_TRACKER",
  APPROVAL: "APPROVAL",
  NPD: "NPD",
};

const { MATERIAL_TRACKER, APPROVAL, NPD } = MODULES;

export const USER_ROLES = [
  { name: "Buyer / Requester", value: "BUYER", modules: [MATERIAL_TRACKER, APPROVAL, NPD] },
  { name: "Purchase Head", value: "PURCHASE_HEAD", modules: [MATERIAL_TRACKER, APPROVAL] },
  { name: "Planner", value: "PLANNER", modules: [MATERIAL_TRACKER] },
  { name: "Plant Head", value: "PLANT_HEAD", modules: [MATERIAL_TRACKER, APPROVAL] },
  { name: "Technical Manager", value: "TECHNICAL_MANAGER", modules: [APPROVAL] },
  { name: "Technical Head", value: "TECHNICAL_HEAD", modules: [APPROVAL] },
  { name: "Finance Manager", value: "FINANCE_MANAGER", modules: [APPROVAL] },
  { name: "Finance Head", value: "FINANCE_HEAD", modules: [APPROVAL] },
  { name: "CEO", value: "CEO", modules: [APPROVAL] },
  { name: "CFO", value: "CFO", modules: [APPROVAL] },
  { name: "CMD", value: "CMD", modules: [APPROVAL] },
  { name: "COO", value: "COO", modules: [APPROVAL] },
  { name: "Finance/Invoice Processor", value: "FINANCE_PROCESSOR", modules: [APPROVAL] },
  { name: "Account Payable Team", value: "ACCOUNT_PAYABLE_TEAM", modules: [APPROVAL] },
  { name: "Superuser", value: "SUPERUSER", modules: [APPROVAL] },
];

export const ALL_USER_ROLE_VALUES = USER_ROLES.map((role) => role.value);

// Roles that get the Planner dashboard and navigation in Material Tracker.
const PLANNER_VIEW_ROLES = ["PLANNER", "PLANT_HEAD"];

export const hasPlannerView = (user) =>
  PLANNER_VIEW_ROLES.some((role) => user?.userRole?.includes(role));

export const getModuleRoles = (module) =>
  USER_ROLES.filter((role) => role.modules.includes(module)).map((role) => role.value);

// ADMIN manages every module, so it can open all of them.
export const canAccessModule = (role, module) =>
  role === "ADMIN" || getModuleRoles(module).includes(role);

// Admin screens are shared by every module; the base path is taken from the current URL
// so the same component works under both /admin and /approval/admin.
export const APPROVAL_ADMIN_BASE = "/approval/admin";
export const MATERIAL_ADMIN_BASE = "/admin";

export const useAdminBasePath = () => {
  const { pathname } = useLocation();
  return pathname.startsWith(APPROVAL_ADMIN_BASE) ? APPROVAL_ADMIN_BASE : MATERIAL_ADMIN_BASE;
};
